module.exports = __webpack_public_path__ + "static/media/mobile_app_background.1a21747f.png";